import React, { useRef, useEffect, useState } from 'react';
import Select from 'react-select';
// import { MultiSelect } from 'react-select';
import { Modal, NavItem } from "react-bootstrap";

import Breadcrumb from '../../../components/Common/Breadcrumb';
import { Col, Label, Button, Card, CardBody, Row, ToastHeader } from 'reactstrap';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { MDBDataTable } from "mdbreact";
import "./Notification.scss"
import notificationimages from "../../../assets/images/notificationimages/img5.png";
import axios from 'axios';
import accessToken from '../../../helpers/jwt-token-access/accessToken';


function Notification() {
  const [popupData, setpopupData] = useState({});
  const [popupView, setpopupView] = useState(false);

  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";



  const reset = () => {
    
  }


  const handleTableData = (item) => {
    axios
    .get(`${API_URL}notifications` , {
      headers: {
        "x-access-token": accessToken,
      },
    })
    .then((res) => {



      item.action = (
        <div style={{ display:"flex" , justifyContent:"center"}}>
          <i
             className="fas fa-eye"
             style={{
              
             }}
           >

          </i>
        </div>

      )
    })
  }


  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Date",
        field: "Date",
        sort: "asc",
        width: 270,
      },
      {
        label: "Time",
        field: "Time",
        sort: "asc",
        width: 150,
      },
      {
        label: "Title",
        field: "Title",
        sort: "asc",
        width: 270,
      },
      {
        label: "Type",
        field: "NotificationType",
        sort: "asc",
        width: 270,
      },
      {
        label: "For",
        field: "NotificationFor",
        sort: "asc",
        width: 150,
      },
      {
        label: "Url",
        field: "Url",
        sort: "asc",
        width: 150,
      },
      {
        label: "Staff",
        field: "staff",
        sort: "asc",
        width: 100,
      },
      {
        label: "Action",
        field: "action",
        sort: "asc",
        width: 150,
      },

    ],
    rows: [

      {
        id: "1",
        Title: "Order delivered",
        staff: "AdminCargo",
        // Icon: (<img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAIUAhQMBIgACEQEDEQH/xAAbAAEAAwEBAQEAAAAAAAAAAAAAAQYHBAUCA//EADkQAAEDAwEGBAMFBwUAAAAAAAEAAgMEBREGBxIhMUFRE2FxgSIykRRCUqGxFRYjJENicggzorLw/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAECA//EAB0RAQEBAAIDAQEAAAAAAAAAAAABEQIhMUFRYRL/2gAMAwEAAhEDEQA/ANwREQEREBERAREQEREBERAREQSihEEooRBKhEQFKhEBERBKhFVdY7QLBo98cN2mldUyN3209Ozffu5xk8QAOfM8cFBa1Cy9m3XSbntaae6tBON4wMwPo9aHZrrRXu2wXG1ztnpJ25jkb17gjmCDwIKDuUIiAiIgIiICIiAiIgIiICzbVe2G0WO7SW6io57pJTn+ZkgeAyLHMA8ckdenmm3HUlxsen6Sktcpp5LlK6GSq5eGwDiAehOefYFfrobR1u0vaRDCI6mpqGA1FSQCJcjkP7ePL3Ksmj3rTr3TdysX7ZF0gp6YYEral4Y+J/4SO/pz6ZWW2mvt2rdttfXwFtbQMpN6nMkfD4WMbkBw/EXfVezPsh07NenV29UR0jjvGhjO6ze8ncw3yH16KyB+l9HwCLet1qY4YxlrXPH/AGctTj9TXVc7Pbqm21cLrfSkSQPbjwW/hPkqJsH1hZrdp6WzXa6RU1Uax74GTndaWFrOAceGd7e4ZyrRBtB0jPLuR36mDv7w9g+rgAvzvWidLaopzOaWAPkB3KyicGuz34cHe4KvKb4SdOjWe1a0aarxbaSCS7V/34qZ4xH5F3Hj5AHzwva0RrW1azoH1Ftc6OaI4mppSPEj7HhzB6FV3RWg7VpIPlpy6prZOBqpWjeDfwtHQd+6p20a1fuTdabWGmqmOhqHzbktL92UnicN7HHEe4wVm8bIut5HFFzWyqNbbqWrMbozPCyXcdzbvAHB+q6VlRERAREQEREBEVV2laqdo/S0tzhiZLUukbDTsfnd33ZOTjoACfZB97R7Zabno65C+5FNTxOnbK0fHE9oOHN8+mOucdVR9iU1zn0i43BxdSMmLKIu+bcHzD/EHgPQ9l41wtm1LV1oMFyuFCygrGskNO7cZw4OAO6wu7HGVfHiLR2iXeEGubbKI4wOD3BvP3cfzW+M9pVW19ravbdW6Y0k3xLk/hPUDj4PkOxHMk8vXl5Fv2d2ymjdX6orX1tS74pZJZiyMHzcTk+pPsmy+iZTWas1HcX71TWPfJJM/mGNJJPuck+y+NLacrtq1yqLpd6mal0/TS7kMEZALj2HTkQS4554HlepNqeXY2xaBuR+y0/7NfIeQp6ob59MOXl1mnb5oWV920jXTTUrPinopRvZHctHBw8+BCvdz2JaUqaN0dAKqiqMfBM2YvwfNruY9MKqaOuF0tOoK3R+o5PEqqYE08pOd9oAOMnmC34hnjzHTCSzl0Zi+6N1PSarsrK+lHhyA7s8BOTE/tnqOoPVZ/W0Tb1ttgturnF1C0b1vg/pvGN5rT5Eh2e5GOS+NNj909rL7dB8NBd4y5sY4BruJH0cHAeTlaNo+krlfqq1XOwTQQXO3yZbJK7d4Z3m4ODycOR7lL3BqjcAYHJSsROste6LudA7WUtJXWyqm8N742sDmDhkgsA4jnxBzgrb1zaQilEEIpRBCIiAsv8A9RDHO0JAWtJDbhGXEDkNx4/UhaguK8Wqivdtnt10p2z0k7d2SN3XsQehB4ghBW7FcaGotNCYKynkBp4/klafuheZtMhfPoK9Mj+YQb/s1zXH8gVV9cbGLPbtO3K52Oa4Oq6eMzMglka5haOLh8u9ndzjjzVl0Bd4dUaKpjUESOERpatmcneA3Tn1bg+66TlvTOYqenGm47LPApeMrqGaEAdX/EMf+7qz7ALhTVOhhRROH2ijqJBMzqN47zT6YOPYqiaXqpNC6krNL3p+5SyyeJR1Dj8JzwB9HDHoQvQuelbxaL0+/wCiK4UtVJky0ziA1+eeMjBBPHB68iln9QnTd+iwvUNRFdtukbqBwey30/h1D28RvBjgfzeG/VKq+bV7vC6ifHSW1jxuvqIixrseoc4j2C/ezWq16AslRWV1T4kz+M85HF56MYPX34knynHjd2ra4L/ip2s6Xp4T/EhLJH47Bxd+jT9Vrr3tjbvSOa1vdxwFluyq21d7v9w1pcoyxsuYqNhPTkSPIABuepJXztFadYa9smj6V7vCjd4lW6M/JkZPuGDr1crvtM9I24VdNVUtlpaaoimqPtZPhRPDnYwByHmVuioGm9kWlrBcIq+JtXWVELw+I1crXBjhyOGtAJHnlX9Yt2tJUIigIilAUIiAiIgz/bJqur03YIaa1j+fub3U8Umf9sY+Jw8+IA9c9Fz7OdJDSVk8CWTxK2oIkqS0/C12MBrfIDr14qxa+0hSazsbqCqeYpoyZKadv9N+McR1HcLLLPry4aJ+0ae1vS1ElRRs/lpo/iMrfujJ5js72PELXGyJV/1bpS2aroRTXKMiSPJhqGfPETzx3HLIPPCzwWHaFpT+BbJIbzQNOGMccuaPQkOHoCQvugq9qN7Y7VFrga2hcf4NucRiSPuGnBcP7sgnpwVl0Xrye+3iayXa0S265wRGR7SSBwxkbp4t+YHqtbKisftvaFVAxU2knQyfjljcG/8AIgfmuq17N7ve65lw13cfGaw5bRQP4ehIwGj/AB591qb3tjY57/laCT6LK2671drEvp9EWF8UWdx1ZMQ7c9zhjTxzjiUt+k/GpU8EVNBHBTxMihiaGsjY3da1o5ADssr1vR1ug9Vx64srxJBUSeHWU8h5l3MejsexHZKHV+oNCXJ9o2gRTVMDwX09dF8ZPoeG836EeiizWm67W7226XZklHpekeRBAHYMxB5DufxO6ch5S8pYSNvt9VHXUNPWQ58KoibKzI44cAR+q6F8QsbFE2ONoaxoDWtHIAL7WGhERARQpQQiIgIpUIC5qu30VaYzW0lPUGM7zDNE1+6e4yOC6UQQGgDAGB5LEtdOrtF7UpdVut1RV2ytpwx74hwYdxrCCeh+Fp488rbkQYXW7YKeqo56aksVd9omjdHHlwxvEYHLirrsSsFZYNEtjuML4KirqH1JikGHMBDWgEdDhoOPNaAoVt0c9ZQ0ldF4VdSwVMec7k0YeM+hX6xxMiY1kTGsY0YDWjAA9F9ooClAiAiIgIiIIREQEREBERAREQEREBERBIRAiAiIgIiIIREQEREBERAREQEREBERBKIiAiIgIiIP/9k=" alt=""width="40"
        // height="40"></img>),
        Date: "08-11-2022",
        Time: "10:00 am",
        NotificationFor: "Customer",
        CustomerStaff: "",
        NotificationType: (<img src="data:image/png;base64,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" alt="" width="20"
          height="20"></img>),
        Url: "",
        action: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              className="fas fa-eye"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.2em",
                marginRight: "0.5em",
              }}
              onClick={() => {
                // handleClickOpenForm(item);
                setpopupView(true);
              }}
            ></i>
            <i
              className="far fa-edit"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.1em",
                marginRight: "0.5em",
              }}
            ></i>
            <i
              className="far fa-trash-alt"
              style={{ fontSize: "1em", cursor: "pointer" }}
            ></i>
          </div>
        ),
      },

      {
        id: "2",
        Title: "Order dispatched",
        staff: "AdminCargo",
        NotificationType: (<img src="data:image/png;base64,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" alt="" width="20"
          height="20"></img>),
        Date: "15-11-2022",
        Time: "10:00 am",
        NotificationFor: "Staff",
        Url: "",
        // city: "Kannur",
        // addedby: "admin",
        action: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              className="fas fa-eye"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.2em",
                marginRight: "0.5em",
              }}
              onClick={() => {
                // handleClickOpenForm(item);
                setpopupView(true);
              }}
            ></i>
            <i
              className="far fa-edit"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.1em",
                marginRight: "0.5em",
              }}
            ></i>
            <i
              className="far fa-trash-alt"
              style={{ fontSize: "1em", cursor: "pointer" }}
            ></i>
          </div>
        ),
      },

      {
        id: "3",
        Title: "Order shipped",
        staff: "AdminCargo",
        NotificationType: (<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB7CAMAAABjGQ9NAAAAY1BMVEX///8AAAB9fX2bm5vk5OTq6uqoqKj19fXx8fH5+fnX19ft7e24uLg6Ojrh4eE9PT00NDRZWVlJSUlRUVFeXl7R0dHCwsJra2uIiIgbGxsWFhaSkpIJCQlxcXEvLy8qKiojIyPQM/+mAAAEcklEQVRoge2a2cKiMAyFi4IgIiAKuP3o+z/lDJCUrUvK5g3n5h8Z5MM2PW3SMrZp06ZNmzZtmqCjfbjv1tH9YB/b6OBsralzwMlesiq5VOLV6PCxOtqyHmGJdqMfoC0rcv+z7/Dhsl9HF+DdGXPwRa7OKiPKuSLQYQFvhWe4Ajp8cl7A8lYf+Iuj/RYtZ3H55wUfs4XRGXAqXszeVdP73/riYVH0oYZ8/SrI3qz6ZDMfnG2/IHpfI84+s6t/IJvZEQ/9hQSDOSphXTbzAP63EPoP0KWb9tmMwai/LILuPHzIxldDo59ROF1BowrY2CWJLX3IONlJN5hEbAzFeF6LC+PeIBKy0WKfc1qcDz7arBjEbG496WzoFJ7YMk0Jm1tuMHjIOOFk1W5JGZuF317vTBJE0LcTQVI2C8FlXjOgYZaKusErZ/P5fTcZvasf1F+XKNjMvXSsYLTArC5u77qKzS3wNgl9A/TgP9RsbK3zeH/1ztKe07AxSoqx/moX8ojVsXGV8Rlncf6n/rpwJaRlc1cYY3FoZmKH0rO5v5ovITXfJLBH+6vIR03ZzIFeM/NX8NGPNNMhsZmTSAeKVDA8E3mSRWOzk7HFoZmd5LcQ2cyFrCk/Km5qdMTb+z46hs1/yFX1NP6mV0oz0dnYgYWiFUGnghQeBmwM3LfO4vw3bViYsHHAvtUWl76JdmDEJlkc3QbN2BqDLmVg/4Zs7q+yFB2mPVLxwpTN/VWcJUM6JffRSWzmdhO6jjCNpHjAGDa3uFvf4o6wMlOa2TQ2D7hrdxXnYc2MusoYwc5g/PbmKIfXgt/EVYY5GyO51Lf5iv1tXacVqozZL6sjbN+0e5mUSJmyIc4KB+2r/onYGJkD00g+O9u9NVGGvzTZB3vs6rSJuJs+2I3YmB3Wo8tvCrK16jIFjjR9RdqEbffSG8w5QDx3wURK+zw6G6flJo7cdvm55SgQj7qJns7GCaozhWVQO7LiTHvveDZGct+0wtcu37361TAMROVAp7JhvfSgpoQ+bDup1k1ENsyNMT0VtqE3FBVpGhsLJiYlAE9briGxpVULtXQVEwL7GOl+gEzQXJEkl9GznQl1NtwkEFuclh1O2kLBzRFhRVrHnrp1xDeFzNnkHEMqRS6jZo8vtVCeoWSjLU/bPwgtSdup2NhXU/dNbEnMKNh75QAxEQ7T3liRs2FsXvWpvl4n8NeuuUvZaOHEHEMjV2TuMjaWiWYhlxIUqiTs2/DOqcIsTsPGDYPpuxVtQS822wcitieMjOnC6MVVgIB9SoQjYgbBqE1OMrZXiJ1gDoFbFZ6Y7cAib64Nwa7ApR+OiI0JwFJnPWBmqdKGHjt9LIvm8EfaZ2d1evecb/t3qBQYGbLr8y3wTsJFxnzCpVAG51uqhTyMv8fSJ5rwqFzFi9vnmZ5zTFxqnVqZe946xxXNf7xjKK85qRc059cGBbtlhMWJ8vwaP7eXr3RuDzu5nDN+eV7xl+c0f3o+lf3yXC776XnkTZs2bdq0aZOp/gF35DMVf8uI7QAAAABJRU5ErkJggg==" alt="" width="20"
          height="20"></img>),
        Date: "15-11-2022",
        Time: "02:00 pm",
        NotificationFor: "All",
        Url: "",
        // NotificationType:(<i class="fa-solid fa-envelope"></i>),
        // city: "Kozhikode",
        // addedby: "admin",
        action: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              className="fas fa-eye"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.2em",
                marginRight: "0.5em",
              }}
              onClick={() => {
                // handleClickOpenForm(item);
                setpopupView(true);
              }}
            ></i>
            <i
              className="far fa-edit"
              style={{
                fontSize: "1em",
                cursor: "pointer",
                marginLeft: "0.1em",
                marginRight: "0.5em",
              }}
            ></i>
            <i
              className="far fa-trash-alt"
              style={{ fontSize: "1em", cursor: "pointer" }}
            ></i>
          </div>
        ),
      },
      
      // {
      //     id: "4",
      //     Title: "",
      //     staff: "AdminCargo",
      //     // Icon: (<img src="data:image/jpeg;base64,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" alt=""width="40"
      //     // height="40"></img>),
      //     Date: "",
      //     Time: "",
      //     NotificationFor: "",
      //     Url: "",
      //    action: (
      //    <div style={{ display: "flex", justifyContent: "center" }}>
      //    <i
      //    className="fas fa-eye"
      //    style={{
      //    fontSize: "1em",
      //    cursor: "pointer",
      //    marginLeft: "0.2em",
      //    marginRight: "0.5em",
      //    }}
      //    onClick={() => {
      //     // handleClickOpenForm(item);
      //     setpopupView(true);
      //   }}
      //    ></i>
      //    <i
      //    className="far fa-edit"
      //    style={{
      //    fontSize: "1em",
      //    cursor: "pointer",
      //    marginLeft: "0.1em",
      //    marginRight: "0.5em",
      //    }}
      //    ></i>
      //    <i
      //    className="far fa-trash-alt"
      //    style={{ fontSize: "1em", cursor: "pointer" }}
      //    ></i>
      //    </div>
      //    ),
      //    },
      //    {
      //     id: "5",
      //     Title: "",
      //     staff: "AdminCargo",
      //     // Icon: (<img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAIUAhQMBIgACEQEDEQH/xAAbAAEAAwEBAQEAAAAAAAAAAAAAAQYHBAUCA//EADkQAAEDAwEGBAMFBwUAAAAAAAEAAgMEBREGBxIhMUFRE2FxgSIykRRCUqGxFRYjJENicggzorLw/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAECA//EAB0RAQEBAAIDAQEAAAAAAAAAAAABEQIhMUFRYRL/2gAMAwEAAhEDEQA/ANwREQEREBERAREQEREBERAREQSihEEooRBKhEQFKhEBERBKhFVdY7QLBo98cN2mldUyN3209Ozffu5xk8QAOfM8cFBa1Cy9m3XSbntaae6tBON4wMwPo9aHZrrRXu2wXG1ztnpJ25jkb17gjmCDwIKDuUIiAiIgIiICIiAiIgIiICzbVe2G0WO7SW6io57pJTn+ZkgeAyLHMA8ckdenmm3HUlxsen6Sktcpp5LlK6GSq5eGwDiAehOefYFfrobR1u0vaRDCI6mpqGA1FSQCJcjkP7ePL3Ksmj3rTr3TdysX7ZF0gp6YYEral4Y+J/4SO/pz6ZWW2mvt2rdttfXwFtbQMpN6nMkfD4WMbkBw/EXfVezPsh07NenV29UR0jjvGhjO6ze8ncw3yH16KyB+l9HwCLet1qY4YxlrXPH/AGctTj9TXVc7Pbqm21cLrfSkSQPbjwW/hPkqJsH1hZrdp6WzXa6RU1Uax74GTndaWFrOAceGd7e4ZyrRBtB0jPLuR36mDv7w9g+rgAvzvWidLaopzOaWAPkB3KyicGuz34cHe4KvKb4SdOjWe1a0aarxbaSCS7V/34qZ4xH5F3Hj5AHzwva0RrW1azoH1Ftc6OaI4mppSPEj7HhzB6FV3RWg7VpIPlpy6prZOBqpWjeDfwtHQd+6p20a1fuTdabWGmqmOhqHzbktL92UnicN7HHEe4wVm8bIut5HFFzWyqNbbqWrMbozPCyXcdzbvAHB+q6VlRERAREQEREBEVV2laqdo/S0tzhiZLUukbDTsfnd33ZOTjoACfZB97R7Zabno65C+5FNTxOnbK0fHE9oOHN8+mOucdVR9iU1zn0i43BxdSMmLKIu+bcHzD/EHgPQ9l41wtm1LV1oMFyuFCygrGskNO7cZw4OAO6wu7HGVfHiLR2iXeEGubbKI4wOD3BvP3cfzW+M9pVW19ravbdW6Y0k3xLk/hPUDj4PkOxHMk8vXl5Fv2d2ymjdX6orX1tS74pZJZiyMHzcTk+pPsmy+iZTWas1HcX71TWPfJJM/mGNJJPuck+y+NLacrtq1yqLpd6mal0/TS7kMEZALj2HTkQS4554HlepNqeXY2xaBuR+y0/7NfIeQp6ob59MOXl1mnb5oWV920jXTTUrPinopRvZHctHBw8+BCvdz2JaUqaN0dAKqiqMfBM2YvwfNruY9MKqaOuF0tOoK3R+o5PEqqYE08pOd9oAOMnmC34hnjzHTCSzl0Zi+6N1PSarsrK+lHhyA7s8BOTE/tnqOoPVZ/W0Tb1ttgturnF1C0b1vg/pvGN5rT5Eh2e5GOS+NNj909rL7dB8NBd4y5sY4BruJH0cHAeTlaNo+krlfqq1XOwTQQXO3yZbJK7d4Z3m4ODycOR7lL3BqjcAYHJSsROste6LudA7WUtJXWyqm8N742sDmDhkgsA4jnxBzgrb1zaQilEEIpRBCIiAsv8A9RDHO0JAWtJDbhGXEDkNx4/UhaguK8Wqivdtnt10p2z0k7d2SN3XsQehB4ghBW7FcaGotNCYKynkBp4/klafuheZtMhfPoK9Mj+YQb/s1zXH8gVV9cbGLPbtO3K52Oa4Oq6eMzMglka5haOLh8u9ndzjjzVl0Bd4dUaKpjUESOERpatmcneA3Tn1bg+66TlvTOYqenGm47LPApeMrqGaEAdX/EMf+7qz7ALhTVOhhRROH2ijqJBMzqN47zT6YOPYqiaXqpNC6krNL3p+5SyyeJR1Dj8JzwB9HDHoQvQuelbxaL0+/wCiK4UtVJky0ziA1+eeMjBBPHB68iln9QnTd+iwvUNRFdtukbqBwey30/h1D28RvBjgfzeG/VKq+bV7vC6ifHSW1jxuvqIixrseoc4j2C/ezWq16AslRWV1T4kz+M85HF56MYPX34knynHjd2ra4L/ip2s6Xp4T/EhLJH47Bxd+jT9Vrr3tjbvSOa1vdxwFluyq21d7v9w1pcoyxsuYqNhPTkSPIABuepJXztFadYa9smj6V7vCjd4lW6M/JkZPuGDr1crvtM9I24VdNVUtlpaaoimqPtZPhRPDnYwByHmVuioGm9kWlrBcIq+JtXWVELw+I1crXBjhyOGtAJHnlX9Yt2tJUIigIilAUIiAiIgz/bJqur03YIaa1j+fub3U8Umf9sY+Jw8+IA9c9Fz7OdJDSVk8CWTxK2oIkqS0/C12MBrfIDr14qxa+0hSazsbqCqeYpoyZKadv9N+McR1HcLLLPry4aJ+0ae1vS1ElRRs/lpo/iMrfujJ5js72PELXGyJV/1bpS2aroRTXKMiSPJhqGfPETzx3HLIPPCzwWHaFpT+BbJIbzQNOGMccuaPQkOHoCQvugq9qN7Y7VFrga2hcf4NucRiSPuGnBcP7sgnpwVl0Xrye+3iayXa0S265wRGR7SSBwxkbp4t+YHqtbKisftvaFVAxU2knQyfjljcG/8AIgfmuq17N7ve65lw13cfGaw5bRQP4ehIwGj/AB591qb3tjY57/laCT6LK2671drEvp9EWF8UWdx1ZMQ7c9zhjTxzjiUt+k/GpU8EVNBHBTxMihiaGsjY3da1o5ADssr1vR1ug9Vx64srxJBUSeHWU8h5l3MejsexHZKHV+oNCXJ9o2gRTVMDwX09dF8ZPoeG836EeiizWm67W7226XZklHpekeRBAHYMxB5DufxO6ch5S8pYSNvt9VHXUNPWQ58KoibKzI44cAR+q6F8QsbFE2ONoaxoDWtHIAL7WGhERARQpQQiIgIpUIC5qu30VaYzW0lPUGM7zDNE1+6e4yOC6UQQGgDAGB5LEtdOrtF7UpdVut1RV2ytpwx74hwYdxrCCeh+Fp488rbkQYXW7YKeqo56aksVd9omjdHHlwxvEYHLirrsSsFZYNEtjuML4KirqH1JikGHMBDWgEdDhoOPNaAoVt0c9ZQ0ldF4VdSwVMec7k0YeM+hX6xxMiY1kTGsY0YDWjAA9F9ooClAiAiIgIiIIREQEREBERAREQEREBERBIRAiAiIgIiIIREQEREBERAREQEREBERBKIiAiIgIiIP/9k=" alt=""width="40"
      //     // height="40"></img>),
      //     Date: "",
      //     Time: "",
      //     NotificationFor: "",
      //     Url: "",
      //    action: (
      //    <div style={{ display: "flex", justifyContent: "center" }}>
      //    <i
      //    className="fas fa-eye"
      //    style={{
      //    fontSize: "1em",
      //    cursor: "pointer",
      //    marginLeft: "0.2em",
      //    marginRight: "0.5em",
      //    }}
      //    onClick={() => {
      //     // handleClickOpenForm(item);
      //     setpopupView(true);
      //   }}
      //    ></i>
      //    <i
      //    className="far fa-edit"
      //    style={{
      //    fontSize: "1em",
      //    cursor: "pointer",
      //    marginLeft: "0.1em",
      //    marginRight: "0.5em",
      //    }}
      //    ></i>
      //    <i
      //    className="far fa-trash-alt"
      //    style={{ fontSize: "1em", cursor: "pointer" }}
      //    ></i>
      //    </div>
      //    ),
      //    },

    ],
  };

  return (
    <React.Fragment>
      <Modal
        show={popupView}
        isOpen={popupView}
        toggle={() => setpopupView(!popupView)}
        size="xl"
        centered={true}>

        <div className='modal-header'>
          <h5 className='modal-title mt-0'>Notification Details</h5>
          <button
            type='button'
            onClick={() => {
              setpopupView(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="close"
          ></button>
        </div>
        <AvForm className="needs-validation">
          <div className='modal-body'>
            <table
              className="table table-bordered dataTable"
            >
              <tr>
                <td style={{ padding: "10px", textAlign: "left" }}>Title</td>
                <td>: Order delivered</td>
                <td style={{ paddingLeft: "25px" }}>Message</td>
                <td style={{ textAlign: "left" }}>: Your order delivered on</td>
                <td style={{ paddingLeft: "25px" }}>UpdatedBy</td>
                <td style={{ textAlign: "left" }}>: Admin Cargo</td>
                {/* <td style={{ paddingLeft: "25px" }}> Image</td>
                {/* <td style={{ textAlign: "left" }}>: </td> */}
                {/* <td>
              
             : <img src={notificationimages} alt=""width="50"
        height="50"></img>
              
              </td>   */}

              </tr>
              <tr>
                <td style={{ padding: "10px", textAlign: "left" }}>Notification For</td>
                <td >: Customer</td>
                <td style={{ paddingLeft: "25px" }}>Customer/Staff</td>
                <td style={{ textAlign: "left" }}>: Anisha Srv</td>
                <td style={{ paddingLeft: "25px" }}>CreatedAt</td>
                <td style={{ textAlign: "left" }}>: 01-11-2022 2:30pm</td>

              </tr>

              <tr>
                <td style={{ padding: "10px", textAlign: "left" }}>Notification Type</td>
                <td>

                  : <img src="data:image/png;base64,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" width={"20%"} height={"20%"}></img>

                </td>
                <td style={{ paddingLeft: "25px" }}>Url</td>
                <td style={{ textAlign: "left" }}>: </td>
                {/* <td style={{ paddingLeft: "25px" }}>CreatedAt</td>
                <td style={{ textAlign: "left" }}>: 01-11-2022 2:30pm </td> */}

              </tr>
              <tr>
                <td style={{ padding: "10px", textAlign: "left" }}>AddedBy</td>
                <td >: Admin Cargo</td>
                <td style={{ paddingLeft: "25px" }}>UpdatedAt</td>
                <td style={{ textAlign: "left" }}>: 30-11-2022 11:25am</td>
                <td style={{ paddingLeft: "25px" }}> Image</td>



                <td>  : <img src={notificationimages} alt="" width={"80"}
                  height={"80"}></img>

                </td>

              </tr>

            </table>
          </div>
        </AvForm>
      </Modal>
      <div className='page-content'>
        <div className='container-fluid'>
          <Breadcrumb title="Home" breadcrumbItem="Notification" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm
                    className="needs-validation"
                    // ref={formRef}
                    onValidSubmit={(e, v) => {
                      //   handleValidSubmit(e, v);
                    }}
                  >
                    <Row>
                      <Col md="3">
                        <div className='mb-3'>
                          <Label>Title</Label>
                          <AvField
                            name="Title"
                            placeholder="Title"
                            type="text"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          // errorMessage="Enter Cargo Type"
                          // onChange={handleChangeInput}
                          // value={cargoobject?.cargo_Type}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className='mb-3'>
                          <Label>Message</Label>
                          <AvField
                            name="Message"
                            placeholder="Message"
                            type="textarea"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            rows="1"
                          // errorMessage="Enter Cargo Type"
                          // onChange={handleChangeInput}
                          // value={cargoobject?.cargo_Type}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3">
                          <Label>Notification Type</Label>
                          <Select
                            isMulti
                            name="Notification Type"
                            // value={selectedTechno}
                            // onChange={(selected) => {
                            // //   handleSelectChange(selected, "Techno");
                            // }}
                            //  displayValue="NotificationType"
                            options={[
                              { label: "SMS" },
                              { label: "WHATS UP" },
                              { label: "EMAIL" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className='mb-3'>
                          <Label>Url</Label>
                          <AvField
                            name="Url"
                            placeholder="Url"
                            type="text"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          // errorMessage="Enter Cargo Type"
                          // onChange={handleChangeInput}
                          // value={cargoobject?.cargo_Type}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3" >
                          <Label>Notification For</Label>
                          <Select
                            name='Notification For'
                            placeholder='Notification For'
                            // value={selectedItem}
                            // validate={{required:{value:true}}}
                            // onChange={(selected) => {
                            // //   handleSelectChange(selected)
                            // }}
                            options={[
                              { label: "Customer" },
                              { label: "Staff" },
                              { label: "All" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                          <p className='text-danger'
                            style={{ fontSize: "11px" }}>
                            {/* {selectedItem===null?errors.StatusFor:""} */}
                          </p>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3" >
                          <Label>Customer/Staff</Label>
                          <Select
                            name='Customer/Staff'
                            placeholder='Customer/Staff'
                            // value={selectedItem}
                            // validate={{required:{value:true}}}
                            // onChange={(selected) => {
                            // //   handleSelectChange(selected)
                            // }}
                            options={[
                              { label: "Abdul Mannan" },
                              { label: "Anisha Srv" },
                              { label: "Afreeda" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                          <p className='text-danger'
                            style={{ fontSize: "11px" }}>
                            {/* {selectedItem===null?errors.StatusFor:""} */}
                          </p>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3">
                          <Label htmlFor="validationCustom03">
                            Image
                          </Label>
                          {/* {userObject?.user_image ? ( */}
                          <div div className="img-wraps">
                            {/* {userObject.user_image &&
 userObject.user_image.startsWith(
 "http"
  ) ? ( */}
                            {/* <img
 alt=""
 width="150"
 height="150"
//  src={`${userObject.user_image}`}
 /> */}
                            {/* ) : ( */}
                            {/* <img
 alt=""
 width="150"
 height="150"
//  src={`${API_URL}/uploads/cargoUser_images/${userObject?.user_image}`}
 /> */}
                            {/* )} */}
                            {/* <button
 className="btn btn-danger btn-sm btn-block waves-effect waves-light btn btn-danger"
//  onClick={deleteImage}
 style={{ width: "150px" }}
 >
 Delete
 </button> */}
                          </div>
                          {/* ) : ( */}
                          <AvField
                            name="Image"
                            type="file"
                            className="form-control"
                            id="validationCustom03"
                            //  onChange={uploadImage}
                            rows="1"
                          />
                          {/* )} */}
                        </div>
                      </Col>

                      <Col md="3" style={{ paddingTop: "4px" }}>
                        <div className='mt-4'>
                          {/* {cargoIdToUpdated ? ( */}
                          {/* <Button className='mx-2'
                                  color='primary'
                                  type='update'>
                                  update
                                </Button> */}
                          {/* )  */}
                          {/* :  */}
                          <Button className='mx-2'
                            color='primary'
                            type='submit'>
                            Submit
                          </Button>
                          {/* } */}
                          <Button
                            color='danger'
                            type='reset'
                            onClick={() => reset()}
                          >
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className='col-12'>
              <Card>
                <CardBody>
                  <MDBDataTable
                    responsive
                    id="Addnotificationtable"
                    bordered
                    data={data}
                    entries={20} />
                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </div>
      </div>

    </React.Fragment>

  )
}

export default Notification